import { render, staticRenderFns } from "./SideDrawer.vue?vue&type=template&id=8c2e1168&scoped=true"
import script from "./SideDrawer.vue?vue&type=script&lang=js"
export * from "./SideDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2e1168",
  null
  
)

export default component.exports